<template>
  <section>
    <!-- Header -->
    <leftMenu />

    <div class="col-xs-12 col-sm-12 col-md-12 back">
      <router-link to="/documentos" class="back-btn">
        <i aria-hidden="true" class="fa fa-arrow-left"/>
        {{$t("Voltar")}}
      </router-link>
    </div>

    <confirm-signature :document-id="documentId" @clear="clearDocumentId" />

    <loading-page v-if="loading" />
    <div v-else>
      <div v-if="dataCode.access" id="mainContent" class="folders">
        <div class="row">
          <loading-page v-if="loading" />
          <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30 box">
            <div class="col-xs-12 col-sm-12 col-md-12 box-title" :style="!dataCode.signinPermission ? 'border-bottom: none;' : ''">
              <h2>
                <strong>{{ dataCode.text }}</strong> ({{ dataCode.result.length }})
              </h2>
            </div>
            <div v-if="dataCode.signinPermission" class="col-xs-12 col-sm-12 col-md-12 box-content">
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-3 box-select">
                <span>{{$t("Status assinatura")}}</span>
                <select v-model="statusSignature">
                  <option value="">{{$t("Todos")}}</option>
                  <option value="0">{{$t("Não solicitado")}}</option>
                  <option value="1">{{$t("Pendente")}}</option>
                  <option value="2">{{$t("Assinado")}}</option>
                </select>
              </div>
              <button @click="getFilteredData(statusSignature)">{{$t("Pesquisar")}}</button>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 box-list">
              <div v-if="dataCode.result.length === 0" class="box-empty">
                <img src="../../../../assets/img/empty/empty-document.png" alt="Vazio">
                <p>{{$t("Nenhum documento encontrado")}}</p>
              </div>
              <table v-else class="box-table table-responsive table-clean">
                <thead>
                <tr>
                  <th class="no-wrap">{{$t("Documento")}}</th>
                  <th class="no-wrap">{{$t("Descrição")}}</th>
                  <th v-if="dataCode.signinPermission" class="no-wrap">{{$t("Assinatura")}}</th>
                  <th class="no-wrap validate">
                    {{$t("Data de validade")}}
                    <div class="tooltip-validate">
                      <svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1.53125C3.98453 1.53125 1.53125 3.98453 1.53125 7C1.53125 10.0155 3.98453 12.4688 7 12.4688C10.0155 12.4688 12.4688 10.0155 12.4688 7C12.4688 3.98453 10.0155 1.53125 7 1.53125ZM7 3.77344C7.14061 3.77344 7.27806 3.81513 7.39498 3.89325C7.51189 3.97137 7.60301 4.0824 7.65682 4.21231C7.71063 4.34222 7.72471 4.48516 7.69728 4.62307C7.66985 4.76098 7.60213 4.88766 7.50271 4.98708C7.40328 5.08651 7.27661 5.15422 7.1387 5.18165C7.00079 5.20908 6.85784 5.195 6.72794 5.1412C6.59803 5.08739 6.487 4.99626 6.40888 4.87935C6.33076 4.76244 6.28906 4.62499 6.28906 4.48438C6.28906 4.29582 6.36396 4.11499 6.49729 3.98167C6.63062 3.84834 6.81145 3.77344 7 3.77344ZM8.3125 9.95312H5.90625C5.79022 9.95312 5.67894 9.90703 5.59689 9.82498C5.51484 9.74294 5.46875 9.63166 5.46875 9.51562C5.46875 9.39959 5.51484 9.28831 5.59689 9.20627C5.67894 9.12422 5.79022 9.07812 5.90625 9.07812H6.67188V6.67188H6.23438C6.11834 6.67188 6.00706 6.62578 5.92502 6.54373C5.84297 6.46169 5.79688 6.35041 5.79688 6.23438C5.79688 6.11834 5.84297 6.00706 5.92502 5.92502C6.00706 5.84297 6.11834 5.79688 6.23438 5.79688H7.10938C7.22541 5.79688 7.33669 5.84297 7.41873 5.92502C7.50078 6.00706 7.54688 6.11834 7.54688 6.23438V9.07812H8.3125C8.42853 9.07812 8.53981 9.12422 8.62186 9.20627C8.70391 9.28831 8.75 9.39959 8.75 9.51562C8.75 9.63166 8.70391 9.74294 8.62186 9.82498C8.53981 9.90703 8.42853 9.95312 8.3125 9.95312Z"/>
                      </svg>
                      <span class="tooltiptext">{{ infoValidate }}</span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, index) in arrayToRender" :key="index">
                  <td class="attachment">
                    <span v-if="value.fileUri">
                      <span v-if="value.isLocked" style="cursor: pointer;" @click="passwordValidate(0, value.id)">
                        <img v-if="value.fileUri.includes('.png') ||
                                  value.fileUri.includes('.webp') ||
                                  value.fileUri.includes('.svg') ||
                                  value.fileUri.includes('.jpeg') ||
                                  value.fileUri.includes('.jpg')"
                            src="../../../../assets/img/attachment-format/img-lock.png" alt="imagem">
                        <img v-else-if="value.fileUri.includes('.pdf')" src="../../../../assets/img/attachment-format/pdf-lock.png" alt="PDF">
                        <img v-else-if="value.fileUri.includes('.xls')" src="../../../../assets/img/attachment-format/xls-lock.png" alt="XLS">
                        <img v-else-if="value.fileUri.includes('.doc')" src="../../../../assets/img/attachment-format/doc-lock.png" alt="Documento">
                        <img v-else-if="value.fileUri.includes('.zip')" src="../../../../assets/img/attachment-format/zip-lock.png" alt="Zip">
                        <img v-else-if="value.fileUri.includes('.rar')" src="../../../../assets/img/attachment-format/rar-lock.png" alt="rar">
                        <img v-else src="../../../../assets/img/attachment-format/undefined-lock.png" alt="Arquivo">
                        <a v-if="value.title === '' || value.title === null" :title="value.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">{{$t("(Sem nome)")}}</a>
                        <a v-else :title="value.title" :style="!dataCode.signinPermission ? 'max-width: 25ch;' : ''" :class="{'attachInline' : value.title.length > 32}">
                          {{ value.title }}
                          <span v-if="dataSignature.document.fileUri.includes('.png') && !dataSignature.document.title.includes('.png')">.png</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.webp') && !dataSignature.document.title.includes('.webp')">.webp</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.svg') && !dataSignature.document.title.includes('.svg')">.svg</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.jpg') && !dataSignature.document.title.includes('.jpg')">.jpg</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.pdf') && !dataSignature.document.title.includes('.pdf')">.pdf</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.xls') && !dataSignature.document.title.includes('.xls')">.xls</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.csv') && !dataSignature.document.title.includes('.csv')">.csv</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.doc') && !dataSignature.document.title.includes('.doc')">.doc</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.zip') && !dataSignature.document.title.includes('.zip')">.zip</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.rar') && !dataSignature.document.title.includes('.rar')">.rar</span>
                          <span v-else-if="value.title.length > 40" style="display: none;"></span>
                          <span v-else></span>
                        </a>
                      </span>
                    <span v-else @click="viewAttachment(value.fileUri)" style="cursor: pointer;">
                      <img v-if="value.fileUri.includes('.png') ||
                                 value.fileUri.includes('.webp') ||
                                 value.fileUri.includes('.svg') ||
                                 value.fileUri.includes('.jpeg') ||
                                 value.fileUri.includes('.jpg')"
                           src="../../../../assets/img/attachment-format/img.png" alt="imagem">
                      <img v-else-if="value.fileUri.includes('.pdf')" src="../../../../assets/img/attachment-format/pdf.png" alt="PDF">
                      <img v-else-if="value.fileUri.includes('.xls')" src="../../../../assets/img/attachment-format/xls.png" alt="XLS">
                      <img v-else-if="value.fileUri.includes('.doc')" src="../../../../assets/img/attachment-format/doc.png" alt="Documento">
                      <img v-else-if="value.fileUri.includes('.zip')" src="../../../../assets/img/attachment-format/zip.png" alt="Zip">
                      <img v-else-if="value.fileUri.includes('.rar')" src="../../../../assets/img/attachment-format/rar.png" alt="rar">
                      <img v-else src="../../../../assets/img/attachment-format/undefined.png" alt="Arquivo">
                      <a v-if="value.title === '' || value.title === null" :title="value.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">
                        {{$t("(Sem nome)")}}
                      </a>
                      <a v-else :title="value.title" :style="!dataCode.signinPermission ? 'max-width: 25ch;' : ''" :class="{'attachInline' : value.title.length > 32}">
                        {{ value.title }}
                        <span v-if="value.fileUri.includes('.png') && !value.title.includes('.png')">.png</span>
                        <span v-else-if="value.fileUri.includes('.webp') && !value.title.includes('.webp')">.webp</span>
                        <span v-else-if="value.fileUri.includes('.svg') && !value.title.includes('.svg')">.svg</span>
                        <span v-else-if="value.fileUri.includes('.jpg') && !value.title.includes('.jpg')">.jpg</span>
                        <span v-else-if="value.fileUri.includes('.pdf') && !value.title.includes('.pdf')">.pdf</span>
                        <span v-else-if="value.fileUri.includes('.xls') && !value.title.includes('.xls')">.xls</span>
                        <span v-else-if="value.fileUri.includes('.csv') && !value.title.includes('.csv')">.csv</span>
                        <span v-else-if="value.fileUri.includes('.doc') && !value.title.includes('.doc')">.doc</span>
                        <span v-else-if="value.fileUri.includes('.zip') && !value.title.includes('.zip')">.zip</span>
                        <span v-else-if="value.fileUri.includes('.rar') && !value.title.includes('.rar')">.rar</span>
                        <span v-else-if="value.title.length > 40" style="display: none;"></span>
                        <span v-else></span>
                      </a>
                    </span>
                    </span>

                    <span v-else-if="!value.fileUri && value.isLocked">
                      <span v-if="value.isLocked" style="cursor: pointer;" @click="passwordValidate(0, value.id)">
                        <img v-if="value.fileUri.includes('.png') ||
                                  value.fileUri.includes('.webp') ||
                                  value.fileUri.includes('.svg') ||
                                  value.fileUri.includes('.jpeg') ||
                                  value.fileUri.includes('.jpg')"
                            src="../../../../assets/img/attachment-format/img-lock.png" alt="imagem">
                        <img v-else-if="value.fileUri.includes('.pdf')" src="../../../../assets/img/attachment-format/pdf-lock.png" alt="PDF">
                        <img v-else-if="value.fileUri.includes('.xls')" src="../../../../assets/img/attachment-format/xls-lock.png" alt="XLS">
                        <img v-else-if="value.fileUri.includes('.doc')" src="../../../../assets/img/attachment-format/doc-lock.png" alt="Documento">
                        <img v-else-if="value.fileUri.includes('.zip')" src="../../../../assets/img/attachment-format/zip-lock.png" alt="Zip">
                        <img v-else-if="value.fileUri.includes('.rar')" src="../../../../assets/img/attachment-format/rar-lock.png" alt="rar">
                        <img v-else src="../../../../assets/img/attachment-format/undefined-lock.png" alt="Arquivo">
                        <a v-if="value.title === '' || value.title === null" :title="value.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">{{$t("(Sem nome)")}}</a>
                        <a v-else :title="value.title" :style="!dataCode.signinPermission ? 'max-width: 25ch;' : ''" :class="{'attachInline' : value.title.length > 32}">
                          {{ value.title }}
                          <span v-if="dataSignature.document.fileUri.includes('.png') && !dataSignature.document.title.includes('.png')">.png</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.webp') && !dataSignature.document.title.includes('.webp')">.webp</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.svg') && !dataSignature.document.title.includes('.svg')">.svg</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.jpg') && !dataSignature.document.title.includes('.jpg')">.jpg</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.pdf') && !dataSignature.document.title.includes('.pdf')">.pdf</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.xls') && !dataSignature.document.title.includes('.xls')">.xls</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.csv') && !dataSignature.document.title.includes('.csv')">.csv</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.doc') && !dataSignature.document.title.includes('.doc')">.doc</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.zip') && !dataSignature.document.title.includes('.zip')">.zip</span>
                          <span v-else-if="dataSignature.document.fileUri.includes('.rar') && !dataSignature.document.title.includes('.rar')">.rar</span>
                          <span v-else-if="value.title.length > 40" style="display: none;"></span>
                          <span v-else></span>
                        </a>
                      </span>
                    </span>

                    <span v-else v-tooltip.bottom="'Documento indisponível no momento'">
                      <img src="../../../../assets/img/attachment-format/undefined.png" alt="Arquivo">
                      <span>{{ value.title }}</span>
                    </span>
                  </td>
                  <td class="description">
                    <span v-if="value.description === '' || value.description === null" :title="value.description" :style="!dataCode.signinPermission ? 'max-width: 50ch;' : ''">-</span>
                    <span v-else :title="value.description" :style="!dataCode.signinPermission ? 'max-width: 50ch;' : ''">{{ value.description }}</span>
                  </td>
                  <td v-if="dataCode.signinPermission" class="sign">
                    <span v-if="value.signatureStatus === 0 || value.signatureStatus === 3" class="sign-none">
                      {{$t("Não solicitado")}}
                    </span>
                    <span v-if="value.signatureStatus === 1" class="sign-content">
                      <img src="../../../../assets/img/default-icons/alert.png" alt="Pendente">
                      <span>
                        {{$t("Pendente")}}
                        <a @click="signDocument(value)">Assinar</a>
                      </span>
                    </span>
                    <span v-if="value.signatureStatus === 2" class="sign-content">
                      <img src="../../../../assets/img/default-icons/success.png" alt="Assinado">
                      <span :style="indexLoading === index ? 'margin-bottom: 18px;' : ''">
                        {{$t("Assinado")}}
                        <div v-if="indexLoading === index" class="loader-container">
                          <div class="spinner">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      <a v-else @click="viewSignature(value.id, index)">Ver assinatura</a>
                      </span>
                    </span>
                    <span v-if="value.signatureStatus === 4" class="sign-content">
                      <ion-icon name="close-circle-outline"></ion-icon>
                      <span :style="indexLoading === index ? 'margin-bottom: 18px;' : ''">
                        {{$t("Recusado")}}
                      </span>
                    </span>
                  </td>
                  <td class="date">
                    <span style="margin-left: 15px" v-if="value.expireAt === '' || value.expireAt === null">-</span>
                    <span v-else>{{ value.expireAt | formatDate }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <div class="modal fade" id="modalPasswordFolder" role="dialog">
      <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
        <!-- Modal content-->
        <div class="modal-content modal-password-folder">
          <div class="modal-header">
            <button type="button" class="close" @click="closeModal(0)" data-dismiss="modal">&times;</button>
            <span>
              <ion-icon name="lock-closed-outline"></ion-icon>
              {{$t("Documento com senha")}}</span>
          </div>
          <div class="body">
            <span>{{$t("Digite sua senha de acesso do aplicativo para abrir este documento")}}</span>
            <div class="body-input">
              <span>{{$t("Sua senha")}}</span>
              <input @keyup.enter="openAttachment" v-model="passwordLocked" type="password" placeholder="Digite Aqui">
              <span v-if="validatePassword" class="validate-password">{{$t("* Digite a sua senha")}}</span>
            </div>
            <div class="body-btn">
              <button @click="closeModal(0)" class="btn-cancel">Cancelar</button>
              <button @click="openAttachment()" :disabled="loadingOpen" class="btn-open">
                <div v-if="loadingOpen" class="loader-container">
                  <div class="spinner">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                  </div>
                </div>
                <span v-else>
                  {{$t("Abrir")}}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalSignatureFolder" role="dialog">
      <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
        <!-- Modal content-->
        <div class="modal-content modal-signature-folder">
          <div class="modal-header">
            <button type="button" class="close" @click="closeModal(1)" data-dismiss="modal">&times;</button>
            <span>
              <ion-icon name="create-outline"></ion-icon>
              {{$t("Assinatura digital")}}
            </span>
          </div>
          <div class="body">
            <div class="row body-signature-by">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 signature-title">
                <span>{{$t("Assinado por")}}</span>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 signature-user">
                <div class="user-details">
                  <span class="user-photo-empty" v-if="dataSignature.user.photo === null">
                    <span>
                      {{ dataSignature.user.name | firstLastName }}
                    </span>
                  </span>
                  <img v-else class="user-photo" :src="dataSignature.user.photo" alt="Foto">
                  <div class="user-title">
                    <span class="name">#{{ dataSignature.user.code }} {{ dataSignature.user.name }}</span>
                    <span class="office">{{ dataSignature.user.officeName }}</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 signature-user-info">
                <div class="info-details">
                  <!-- <span class="info-cpf">
                    CPF: <span>{{ dataSignature.user.cpf }}</span>
                  </span> -->
                  <span class="info-email">
                    {{$t("E-mail:")}} <span>{{ dataSignature.user.email }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="row body-document">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 document-content">
                <span class="document-title">{{$t("Documento:")}}</span>
                <span class="document-attachment">
                  <span v-if="dataSignature.document.fileUri">
                    <span v-if="dataSignature.document.isLocked" style="cursor: pointer;" @click="passwordValidate(1, dataSignature.document.id)">
                    <img v-if="dataSignature.document.fileUri.includes('.png') ||
                               dataSignature.document.fileUri.includes('.webp') ||
                               dataSignature.document.fileUri.includes('.svg') ||
                               dataSignature.document.fileUri.includes('.jpeg') ||
                               dataSignature.document.fileUri.includes('.jpg')"
                         src="../../../../assets/img/attachment-format/img-lock.png" alt="imagem">
                    <img v-else-if="dataSignature.document.fileUri.includes('.pdf')" src="../../../../assets/img/attachment-format/pdf-lock.png" alt="PDF">
                    <img v-else-if="dataSignature.document.fileUri.includes('.xls')" src="../../../../assets/img/attachment-format/xls-lock.png" alt="XLS">
                    <img v-else-if="dataSignature.document.fileUri.includes('.doc')" src="../../../../assets/img/attachment-format/doc-lock.png" alt="Documento">
                    <img v-else-if="dataSignature.document.fileUri.includes('.zip')" src="../../../../assets/img/attachment-format/zip-lock.png" alt="Zip">
                    <img v-else-if="dataSignature.document.fileUri.includes('.rar')" src="../../../../assets/img/attachment-format/rar-lock.png" alt="rar">
                    <img v-else src="../../../../assets/img/attachment-format/undefined-lock.png" alt="Arquivo">
                    <a v-if="dataSignature.document.title === '' || dataSignature.document.title === null" :title="dataSignature.document.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">
                      {{$t("(Sem nome)")}}
                    </a>
                    <a v-else :title="dataSignature.document.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">
                      {{ dataSignature.document.title }}
                      <span v-if="dataSignature.document.fileUri.includes('.png') && !dataSignature.document.title.includes('.png')">.png</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.webp') && !dataSignature.document.title.includes('.webp')">.webp</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.svg') && !dataSignature.document.title.includes('.svg')">.svg</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.jpg') && !dataSignature.document.title.includes('.jpg')">.jpg</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.pdf') && !dataSignature.document.title.includes('.pdf')">.pdf</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.xls') && !dataSignature.document.title.includes('.xls')">.xls</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.csv') && !dataSignature.document.title.includes('.csv')">.csv</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.doc') && !dataSignature.document.title.includes('.doc')">.doc</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.zip') && !dataSignature.document.title.includes('.zip')">.zip</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.rar') && !dataSignature.document.title.includes('.rar')">.rar</span>
                      <span v-else></span>
                    </a>
                  </span>
                    <span v-else @click="viewAttachment(dataSignature.document.fileUri)" style="cursor: pointer;">
                    <img v-if="dataSignature.document.fileUri.includes('.png') ||
                               dataSignature.document.fileUri.includes('.webp') ||
                               dataSignature.document.fileUri.includes('.svg') ||
                               dataSignature.document.fileUri.includes('.jpeg') ||
                               dataSignature.document.fileUri.includes('.jpg')"
                         src="../../../../assets/img/attachment-format/img.png" alt="imagem">
                    <img v-else-if="dataSignature.document.fileUri.includes('.pdf')" src="../../../../assets/img/attachment-format/pdf.png" alt="PDF">
                    <img v-else-if="dataSignature.document.fileUri.includes('.xls')" src="../../../../assets/img/attachment-format/xls.png" alt="XLS">
                    <img v-else-if="dataSignature.document.fileUri.includes('.doc')" src="../../../../assets/img/attachment-format/doc.png" alt="Documento">
                    <img v-else-if="dataSignature.document.fileUri.includes('.zip')" src="../../../../assets/img/attachment-format/zip.png" alt="Zip">
                    <img v-else-if="dataSignature.document.fileUri.includes('.rar')" src="../../../../assets/img/attachment-format/rar.png" alt="rar">
                    <img v-else src="../../../../assets/img/attachment-format/undefined.png" alt="Arquivo">
                    <a v-if="dataSignature.document.title === '' || dataSignature.document.title === null" :title="dataSignature.document.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">
                      {{$t("(Sem nome)")}}
                    </a>
                    <a v-else :title="dataSignature.document.title" :style="!dataCode.signinPermission ? 'max-width: 32ch;' : ''">
                      {{ dataSignature.document.title }}
                      <span v-if="dataSignature.document.fileUri.includes('.png') && !dataSignature.document.title.includes('.png')">.png</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.webp') && !dataSignature.document.title.includes('.webp')">.webp</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.svg') && !dataSignature.document.title.includes('.svg')">.svg</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.jpg') && !dataSignature.document.title.includes('.jpg')">.jpg</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.pdf') && !dataSignature.document.title.includes('.pdf')">.pdf</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.xls') && !dataSignature.document.title.includes('.xls')">.xls</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.csv') && !dataSignature.document.title.includes('.csv')">.csv</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.doc') && !dataSignature.document.title.includes('.doc')">.doc</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.zip') && !dataSignature.document.title.includes('.zip')">.zip</span>
                        <span v-else-if="dataSignature.document.fileUri.includes('.rar') && !dataSignature.document.title.includes('.rar')">.rar</span>
                      <span v-else></span>
                    </a>
                  </span>
                  </span>
                  <span v-else v-tooltip.bottom="'Documento indisponível no momento'">
                    <img src="../../../../assets/img/attachment-format/undefined.png" alt="Arquivo">
                    <span>{{ dataSignature.document.title }}</span>
                  </span>
                </span>
                <button v-on:click="downloadDocumentSignature(dataSignature)" class="default-btn-bue btn-download">
                  <ion-icon v-if="!loadingGenerateMirror" name="print-outline"></ion-icon>
                  <span v-if="!loadingGenerateMirror">{{$t("Imprimir log")}}</span>
                  <div v-if="loadingGenerateMirror" class="loader-container">
                    <div class="spinner">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>
                <span class="document-id">{{$t("ID do documento:")}} <span>{{ dataSignature.document.id }}</span></span>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 signature-content">
                <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 signature-data">
                  <span class="data-title">{{$t("Dados da assinatura:")}}</span>
                  <span class="data-signed">{{$t("Assinado em:")}} <span>{{ dataSignature.signatureDetails.signedAt | formatDateHours }}</span></span>
                  <span class="data-device-id">{{$t("ID do aparelho: ")}}<span>{{ dataSignature.signatureDetails.device }}</span></span>
                  <span class="data-device">{{$t("Modelo do aparelho:")}} <span>{{ dataSignature.signatureDetails.deviceModel }}</span></span>
                  <span class="data-ip">{{$t("IP:")}} <span>{{ dataSignature.signatureDetails.ip }}</span></span>
                </div>
                <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 signature-photo">
                  <div v-if="dataSignature.signatureDetails.selfieUri" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 photo-user">
                    <span>{{$t("Foto:")}}</span>
                    <a :href="dataSignature.signatureDetails.selfieUri" target="_blank">
                      <img :src="dataSignature.signatureDetails.selfieUri" alt="Foto">
                    </a>
                  </div>
                  <div v-if="dataSignature.signatureDetails.signatureUri" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 photo-signature">
                    <span>{{$t("Assinatura:")}}</span>
                    <a :href="dataSignature.signatureDetails.signatureUri" target="_blank">
                      <img :src="dataSignature.signatureDetails.signatureUri" alt="Assinatura">
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 location-content">
                <span class="location-title">{{$t("Localização:")}}</span>
                <div class="location-map">
                  <div id="map"></div>
                </div>
                <span class="location-footer">
                  {{$t("Localização: ")}}{{ dataSignature.signatureDetails.latitude }} | {{ dataSignature.signatureDetails.longitude }}
                </span>
              </div>
            </div>
            <button @click="closeModal(1)" class="close-signature">{{$t("Fechar")}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
import leftMenu from "../../components/leftMenu";
import loadingPage from "../../components/loadingPage";
import vueFooter from "../../components/footer";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {
  DOCUMENT_WEB_PDF_CUSTOM,
  GET_FOLDERS_DETAIL,
  GET_SIGNATURE_DETAIL,
  POST_PASSWORD_ATTACHMENT
} from "../../../../urlConfig";
import {UTIL_SERVICE} from "../../../../utils";
import {GMAPS_UTIL_SERVICE} from "../../../../gMapsUtils";
import swal from "sweetalert";
import ConfirmSignature from "../../modals/modalConfirmSignature.vue";

export default {
  name: "foldersDetail",
  components: {
    ConfirmSignature,
    leftMenu,
    loadingPage,
    vueFooter
  },
  data() {
    return {
      arrayToRender: [],
      oldStatus: '',
      loading: false,
      loadingSignature: false,
      loadingGenerateMirror: false,
      indexLoading: null,
      loadingOpen: false,
      validatePassword: false,
      dataCode: '',
      documentId: null,
      dataSignature: {
        document: {
          fileUri: '',
          id: '',
          isLocked: '',
          title: '',
        },
        signatureDetails: {
          device: '',
          deviceModel: '',
          documentId: '',
          ip: '',
          latitude: '',
          longitude: '',
          selfieUri: '',
          signatureUri: '',
          signedAt: '',
        },
        user: {
          code: '',
          cpf: '',
          email: '',
          id: '',
          name: '',
          officeName: '',
          photo: '',
        },
      },
      width: '100%',
      statusSignature: '',
      passwordLocked: '',
      idLocked: '',
      infoValidate: 'Alguns documentos podem possuir validade, como por exemplo a Carteira de Motorista e exames de saúde ocupacional.',

    }
  },
  methods: {
    clearDocumentId() {
      this.documentId = null;
      this.getData();
    },
    getFilteredData(status) {
      if(status === this.oldStatus) {
        this.$toast.info(this.$t("Verifique se você alterou o status."),
        {
          position: 'top-center',
          maxToasts: 1,
        })
      }

      this.oldStatus = status;
      switch(status) {
        case '0':
          return this.arrayToRender = this.dataCode.result.filter((e) => {
            return e.signatureStatus === 0
          });

        case '1':
          return this.arrayToRender = this.dataCode.result.filter((e) => {
            return e.signatureStatus === 1
          });

        case '2':
          return this.arrayToRender = this.dataCode.result.filter((e) => {
            return e.signatureStatus === 2
          });

        default:
          return this.arrayToRender = this.dataCode.result
      }
    },
    getData() {
      this.loading = true;

      let url = GET_FOLDERS_DETAIL;
      url += this.$route.params.folderId + '?status=' + this.statusSignature;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_FOLDERS_DETAIL:", response.data);

        this.dataCode = response.data;
        this.arrayToRender = this.dataCode.result;
        this.loading = false;

      }).catch(reason => {
        UTIL_SERVICE.console("RESULT GET_FOLDERS_DETAIL:", reason);
        this.loading = false;
      });
    },
    viewAttachment(url) {
      window.open(url, '_blank');
    },
    passwordValidate(value, id) {
      if(value === 1) {
        this.idLocked = id;
        $('#modalSignatureFolder').modal('hide');
        $('#modalPasswordFolder').modal();
      } else {
        this.idLocked = id;
        $('#modalPasswordFolder').modal();
      }
    },
    closeModal(value) {
      if(value === 1) {
        $('#modalSignatureFolder').modal('hide');
      } else {
        $('#modalPasswordFolder').modal('hide');
      }
    },
    viewSignature(value, index) {
      this.loadingSignature = true;
      this.indexLoading = index;

      REQUEST_SERVICE.get(GET_SIGNATURE_DETAIL + value).then((response) => {
        UTIL_SERVICE.console("RESULT GET_SIGNATURE_DETAIL:", response.data);


        this.dataSignature = response.data;
        $('#modalSignatureFolder').modal();
        this.loadingSignature = false;
        this.indexLoading = null;

        GMAPS_UTIL_SERVICE.initMap(this.dataSignature.signatureDetails.latitude, this.dataSignature.signatureDetails.longitude);
        GMAPS_UTIL_SERVICE.addMarker(this.dataSignature.signatureDetails.latitude, this.dataSignature.signatureDetails.longitude);

      }).catch(reason => {
        UTIL_SERVICE.console("RESULT GET_SIGNATURE_DETAIL:", reason);
        this.indexLoading = null;
        this.loadingSignature = false;
      });
    },
    openAttachment() {
      this.loadingOpen = true;

      let obj = {
        documentId: this.idLocked,
      }

      if(this.passwordLocked === '') {
        this.loadingOpen = false;
        return this.validatePassword = true;
      } else {
        obj.password = this.passwordLocked
        this.validatePassword = false;
      }

      REQUEST_SERVICE.post(POST_PASSWORD_ATTACHMENT, obj).then((response) => {
        UTIL_SERVICE.console("RESULT POST_PASSWORD_ATTACHMENT:", response.data);

        if(response.data.access) {
          window.open(response.data.result.fileUri, '_blank');
          $('#modalPasswordFolder').modal('hide');
        } else {
          swal(this.$t("Aviso!"), response.data.text, 'warning')
        }
        this.loadingOpen = false;

      }).catch(reason => {
        UTIL_SERVICE.console("RESULT POST_PASSWORD_ATTACHMENT:", reason);
        this.loadingOpen = false;
      });
    },
    signDocument(value) {
      this.documentId = value.id;
      $('#modalConfirmSignature').modal('toggle');
    },
    downloadDocumentSignature(data) {
      if (!this.loadingGenerateMirror) {
        this.loadingGenerateMirror = true;
        REQUEST_SERVICE.get(DOCUMENT_WEB_PDF_CUSTOM + data.document.id).then((response) => {
          UTIL_SERVICE.console("RESULT MIRROR_WEB_PDF_CUSTOM:", response.data);

          try {
            window.signatureLogOriginal({
              logSignature: {
                idDocument: response.data.document.id,
                convertSignatedAt: response.data.signedAt,
                selfie: response.data.selfie,
                signatureUri: response.data.signature,
                userCpf: response.data.user.cpf,
                userEmail: response.data.user.email,
                userName: response.data.user.name,
                device: response.data.deviceId,
                deviceModel: response.data.deviceModel,
                ip: response.data.ip,
                latitude: response.data.latitude,
                longitude: response.data.longitude,
                documentUri: this.dataSignature.document.fileUri
              }
            }, `${this.$t("assinatura")}-${response.data.document.id}`).then((value) => {
              this.loadingGenerateMirror = false;
            }).catch(reason => {
              this.loadingGenerateMirror = false;
            });
          } catch (e) {
            this.loadingGenerateMirror = false;
          }
        }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'generatorDocumentWebPdf', {id: id}, true, reason.response.data);

          this.loadingGenerateMirror = false;
          // Show errors.
          reason.response.data.erros.map((value) => {
            swal(this.$t("Aviso"), value.value, "error");
          });
        });
      }
    }
  },
  beforeMount() {
    this.getData();
  }
}
</script>

<style lang="scss" scoped>

.attachInline {
  display: list-item !important;
}

.back {
  border-bottom: 2px solid rgba(0, 0, 0, 0.06);
  padding-top: 21px;
  padding-bottom: 19px;

  @media screen and (max-width: 767px) {
    z-index: 1;
  }

  &-btn {
    background: transparent;
    color: var(--linkColor);
    font-size: 15px;
    margin-left: 275px;

    i {
      color: var(--linkColor);
      font-size: 13px;
      cursor: pointer;
      margin-right: 5px;
    }

    @media screen and (max-width: 767px) {
      margin-left: 0;
      z-index: 1;
    }
  }
}

.box-list {
  overflow-x: auto;
}

.folders {
  background: var(--bodyColor);
  padding-bottom: 5% !important;
  padding-right: 3% !important;
}

.box {
  padding: 30px !important;
  background: var(--bodyContrast) 0 0 no-repeat padding-box;
  box-shadow: 0 0 15px #0000000d;
  border-radius: 12px;
  margin-bottom: 30px;

  &-title {
    padding: 0 0 10px 0;
    border-bottom: 1px solid var(--bodyColor);

    h2 {
      font-size: 24px;
      color: var(--titleBox);
      margin: 0;
      font-weight: 400;
    }

    span {
      color: var(--defaultText);
      font-size: 14px;
      font-weight: 400;
      margin-top: 4px;
    }
  }

  &-content {
    margin-top: 20px;
    padding: 0;

    button {
      border-radius: 4px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      background: var(--linkColor);
      border: 1px solid var(--linkColor);
      color: #ffffff;
      margin: 21px 0 0 20px;
      padding: 6px 16px;
      cursor: pointer;
      transition: .2s;
    }
  }

  &-content > &-select {
    padding: 0;

    span {
      font-size: 14px;
      font-weight: 400;
      color: var(--defaultText);
      margin-bottom: 3px;
    }
  }

  &-list {
    padding: 0;
    margin-top: 30px;
  }

  &-list > &-empty {
    margin-top: 20px;
    text-align: center;

    p {
      margin-top: 8px;
      margin-bottom: 18px;
      font-size: 14px;
      font-weight: 400;
      color: var(--defaultText);
    }
  }

  &-list > &-table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    border: none;

    thead {
      tr {
        th {
          font-weight: normal;
          font-size: 15px;
          border-bottom: none;
        }

        .validate {

          .tooltip-validate {
            position: relative;
            display: inline-block !important;

            svg {
              path {
                fill: var(--titleBox);
              }
            }

            &:hover {
              .tooltiptext {
                z-index: 1;
                opacity: 1;
                visibility: visible;
              }
            }

            .tooltiptext {
              visibility: hidden;
              white-space: pre-line;
              width: 288px;
              background-color: var(--titleBox);
              color: #fff;
              text-align: center;
              padding: 5px 9px;
              border-radius: 8px;
              position: absolute;
              left: -250px;
              top: 22px;
              opacity: 0;
              transition: opacity .5s;

              &::after {
                content: " ";
                position: absolute;
                bottom: 100%;
                right: 25.2px;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent transparent black transparent;
              }
            }
          }
        }
      }
    }

    tbody {
      tr {
        td {
          padding: 10px 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
        }

        .attachment {
          span {
            display: flex;
            align-items: center;
            padding-right: 10px;

            img {
              margin-right: 10px;
            }

            a {
              display: flex;
              flex-direction: row;
              font-size: 15px;
              font-weight: 400;
              color: var(--linkColor);
              cursor: pointer;
              padding-right: 5px;
              max-width: 32ch;

              white-space: nowrap;
              overflow: hidden !important;
              text-overflow: ellipsis;
              align-items: center;

              span {
                display: list-item;
                max-width: 15ch;
                white-space: nowrap;
                overflow: hidden!important;
                text-overflow: ellipsis;
              }

              ion-icon {
                font-size: 18px;
                color: var(--textSide);
              }
            }
          }

          .is-locked {
            padding-right: 0;
          }
        }

        .description {
          span {
            display: list-item;
            max-width: 40ch;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
            align-items: center;
            padding-right: 10px;
          }
        }

        .sign {
          padding-right: 10px;
          min-width: 150px;

          .sign-none {
            font-size: 15px;
            font-weight: 400;
            color: var(--defaultText);
          }

          .sign-content {
            display: flex;
            align-items: center;
            position: relative;

            ion-icon {
              font-size: 20px;
              margin-right: 4px;
              color: #FF445D;
            }

            img {
              margin-right: 4px;
              width: 20px;
              height: 20px;
            }

            span {
              display: flex;
              flex-direction: column;
              font-size: 15px;
              font-weight: 400;
              color: var(--textSide);

              a {
                cursor: pointer;
                font-size: 14px;
                font-weight: 400;
                color: var(--linkColor);

                @media screen and (max-width: 857px) {
                  margin: auto;
                }
              }
            }

            .loader-container {
              .spinner {
                position: absolute;
                left: 0;
                top: 20px;
                width: 51px;
                height: 20px;
                margin-left: 30px;

                .rect1, .rect2, .rect3, .rect4, .rect5 {
                  width: 3px;
                  height: 20px;
                }
              }
            }
          }
        }

        .date {
          font-size: 15px;
        }
      }
    }
  }
}

#modalPasswordFolder {
  .modal-dialog {
    max-width: 501px;

    @media only screen and (max-width: 520px) {
      max-width: 96%;
      min-width: 96%;
    }
  }
}

#modalSignatureFolder {
  .modal-dialog {
    max-width: 598px;

    @media only screen and (max-width: 520px) {
      max-width: 96%;
      min-width: 96%;
    }
  }
}

.modal-password-folder {
  padding: 30px;
  box-shadow: none;
  border: none;
  border-radius: 8px;

  .modal-header {
    padding: 0 0 10px 0;
    border-bottom: 1px solid var(--bodyColor);

    .close {
      top: 10px;
      right: 10px;
    }

    span {
      display: flex;
      align-items: center;
      color: var(--titleBox);
      font-size: 21px;
      font-weight: 700;
      line-height: 25.6px;

      ion-icon {
        font-size: 24px;
        margin-right: 8px;
      }
    }
  }

  .body {
    margin-top: 16px;

    span {
      font-size: 16px;
      font-weight: 400;
      color: var(--textSide);
    }

    &-input {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      position: relative;

      .validate-password {
        position: absolute;
        top: 3px;
        right: 0;
        font-size: 11px;
        color: var(--redColor);
      }

      span {
        margin-bottom: 3px;
        color: var(--defaultText);
        font-size: 14px;
        font-weight: 400;
      }

      input {
        font-size: 16px;
        font-weight: 400;
        color: var(--textSide);
        padding: 5px 11px;
        border-radius: 4px;
        border: 1px solid var(--bodyColor);
        transition: .2s;

        &:hover {
          border-color: var(--titleSide);
        }

        &::placeholder {
          color: var(--textSide);
        }
      }
    }

    &-btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;

      .btn-cancel {
        padding: 8px 25px;
        margin-right: 16px;
        border: none;
        border-radius: 4px;
        transition: .2s;
        color: #3A424E;
        background: #D5DFEB;
      }

      .btn-open {
        position: relative;
        background: var(--linkColor);
        padding: 8px 38px;
        border: none;
        border-radius: 4px;
        transition: .2s;

        span {
          color: #FFFFFF;
        }

        .loader-container {
          .spinner {
            position: inherit;
            width: 39.33px;
            height: 22.84px;

            .rect1, .rect2, .rect3, .rect4 {
              background: #FFFFFF !important;
              width: 3px;
              height: 20px;
            }
          }
        }
      }
    }
  }
}

.modal-signature-folder {
  padding: 30px;
  box-shadow: none;
  border: none;
  border-radius: 8px;

  .modal-header {
    padding: 0 0 10px 0;
    border-bottom: 1px solid var(--bodyColor);

    .close {
      top: 10px;
      right: 10px;
    }

    span {
      display: flex;
      align-items: center;
      color: var(--titleBox);
      font-size: 21px;
      font-weight: 700;
      line-height: 29.53px;

      ion-icon {
        font-size: 24px;
        margin-right: 8px;
      }
    }
  }

  .body {
    word-break: break-all;
    margin-top: 16px;

    .body-signature-by {
      margin: 0;

      .signature-title {
        padding: 0;
        margin-bottom: 8px;

        span {
          font-size: 15px;
          font-weight: 700;
          color: var(--titleBox);
        }
      }

      .signature-user {
        padding: 0;

        .user-details {
          display: flex;
          align-items: center;
          flex-direction: row;

          .user-photo-empty {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 41px;
            height: 41px;
            background: var(--bodyColor);
            border-radius: 100%;
            margin-right: 7px;

            span {
              font-weight: bold;
              font-size: 18px;
            }
          }

          .user-photo {
            width: 41px;
            height: 41px;
            border-radius: 50%;
            margin-right: 7px;
          }

          .user-title {
            display: flex;
            flex-direction: column;

            .name {
              color: var(--titleBox);
              font-size: 15px;
              font-weight: 700;
              line-height: 17.07px;
            }

            .office {
              color: var(--textSide);
              font-size: 13px;
              font-weight: 400;
              line-height: 15.47px;
            }
          }
        }
      }

      .signature-user-info {
        padding: 0;

        .info-details {
          display: flex;
          flex-direction: column;

          .info-cpf {
            font-size: 13px;
            font-weight: 400;
            line-height: 15.47px;
            margin-bottom: 8px;
            color: var(--titleBox);

            span {
              font-weight: 700;
            }
          }

          .info-email {
            font-size: 13px;
            font-weight: 400;
            line-height: 15.47px;
            margin-bottom: 8px;
            color: var(--titleBox);

            span {
              font-weight: 700;
            }
          }
        }
      }
    }

    .body-document {
      border: 1px solid var(--bodyColor);
      border-radius: 10px;
      padding: 20px;
      margin: 10px 0 0 0;

      .document-content {
        padding: 0;
        display: flex;
        flex-direction: column;

        .document-title {
          font-size: 15px;
          font-weight: 700;
          color: var(--titleBox);
          margin-bottom: 8px;
        }

        .document-attachment {
          display: flex;
          align-items: center;

          span {
            display: flex;
            align-items: center;

            img {
              margin-right: 6px;
            }

            a {
              display: flex;
              align-items: center;
              font-size: 13px;
              font-weight: 400;
              color: var(--linkColor);
              cursor: pointer;

              ion-icon {
                font-size: 16px;
                margin-left: 8px;
                color: var(--titleBox);
              }
            }
          }
        }

        .btn-download {
          width: 160px;
          position: absolute;
          right: 0;
          top: 5px;
          height: 32px;
          padding: 0;
          background: transparent !important;
          border: 1px solid var(--linkColor);

          span {
            color: var(--linkColor) !important;
            position: relative;
            top: -2px;
            margin-left: 3px;
          }

          ion-icon {
            color: var(--linkColor) !important;
            position: relative;
            top: 3px;
            font-size: 18px;
          }

          .spinner {
            top: 2px;
            right: 0;
            margin: 0 auto;
            height: 28px;
            left: 15px;
          }

          .spinner > div {
            width: 4px;
            height: 26px;
          }
        }

        .document-id {
          margin-top: 10px;
          font-size: 13px;
          font-weight: 400;
          color: var(--titleBox);

          span {
            font-weight: 700;
          }
        }
      }

      .signature-content {
        padding: 0;
        margin-top: 16px;

        .signature-data {
          display: flex;
          flex-direction: column;
          padding: 0;

          .data-title{
            font-size: 15px;
            font-weight: 700;
            color: var(--titleBox);
            margin-bottom: 8px;
          }

          .data-signed {
            font-size: 13px;
            font-weight: 400;
            color: var(--titleBox);
            margin-bottom: 8px;

            span {
              font-weight: 700;
            }
          }

          .data-device-id {
            font-size: 13px;
            font-weight: 400;
            color: var(--titleBox);
            margin-bottom: 8px;

            span {
              font-weight: 700;
            }
          }

          .data-device {
            font-size: 13px;
            font-weight: 400;
            color: var(--titleBox);
            margin-bottom: 8px;

            span {
              font-weight: 700;
            }
          }

          .data-ip {
            font-size: 13px;
            font-weight: 400;
            color: var(--titleBox);
            margin-bottom: 8px;

            span {
              font-weight: 700;
            }
          }
        }

        .signature-photo {
          display: flex;
          justify-content: space-between;
          padding: 0;

          @media screen and (max-width: 767px) {
            margin-top: 16px;
            justify-content: space-around;
          }

          .photo-user {
            display: flex;
            flex-direction: column;
            padding: 0;
            width: max-content;

            span {
              font-size: 15px;
              font-weight: 700;
              color: var(--titleBox);
              width: max-content;
              margin-bottom: 8px;
            }

            img {
              width: 85px;
              height: 115px;
            }
          }

          .photo-signature {
            display: flex;
            flex-direction: column;
            padding: 0;
            width: max-content;

            span {
              font-size: 15px;
              font-weight: 700;
              color: var(--titleBox);
              width: max-content;
              margin-bottom: 8px;
            }

            img {
              width: 85px;
              height: 115px;
            }
          }
        }
      }

      .location-content {
        display: flex;
        flex-direction: column;
        padding: 0;
        margin-top: 16px;

        .location-title {
          font-size: 15px;
          font-weight: 700;
          color: var(--titleBox);
          margin-bottom: 8px;
        }

        .location-map {
          margin-bottom: 4px;

          div {
            width: 100%;
            height: 213px;
          }
        }

        .location-footer {
          font-size: 13px;
          font-weight: 400;
          color: var(--titleBox);
        }
      }
    }

    .close-signature {
      width: 100%;
      padding: 10px 0;
      margin-top: 20px;
      border: none;
      border-radius: 4px;
      transition: .2s;
      color: #3A424E;
      background: #D5DFEB;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/documents/foldersDetail.vue